import setters from './setters';
import services from './services';
import general from './general';

export default { ...setters, ...services, ...general };
